import {Construtor} from './construtor';
import { CriterioReincidenciaOcorrencia } from './criterio-reincidencia-ocorrencia';

export class ReincidenciaOcorrencia implements Construtor<ReincidenciaOcorrencia> {

  public idReincidenciaOcorrencia: number;
  public idConfigOcorrenciaAuto: number;
  public idUsuario: number;
  public quantidadeOcorrencias: number;
  public dataInicioReferencia: Date;
  public dataFimReferencia: Date;
  public conteudoEmail: string;
  public mesesAte: number;
  public semanasAte: number;
  public diasAte: number;
  public criterios: CriterioReincidenciaOcorrencia[];

  constructor(object?: any) {
    this.criterios = new Array<CriterioReincidenciaOcorrencia>();

    if (object !== undefined) {

      if (object instanceof ReincidenciaOcorrencia) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      return this.modeloCompleto() ? this : null;
    }

    return this;
  }

  copyObject(ocorrencia: ReincidenciaOcorrencia): void {
    this.idReincidenciaOcorrencia = ocorrencia.idReincidenciaOcorrencia;
    this.idConfigOcorrenciaAuto = ocorrencia.idConfigOcorrenciaAuto;
    this.idUsuario = ocorrencia.idUsuario;
    this.quantidadeOcorrencias = ocorrencia.quantidadeOcorrencias;
    this.dataInicioReferencia = ocorrencia.dataInicioReferencia;
    this.dataFimReferencia = ocorrencia.dataFimReferencia;
    this.conteudoEmail = ocorrencia.conteudoEmail;
    this.mesesAte = ocorrencia.mesesAte;
    this.semanasAte = ocorrencia.semanasAte;
    this.diasAte = ocorrencia.diasAte;
    this.criterios = ocorrencia.criterios;
  }

  parseFromJson(ocorrencia: any): void {
    this.idReincidenciaOcorrencia = ocorrencia.idReincidenciaOcorrencia;
    this.idConfigOcorrenciaAuto = ocorrencia.idConfigOcorrenciaAuto;
    this.idUsuario = ocorrencia.idUsuario;
    this.quantidadeOcorrencias = ocorrencia.quantidadeOcorrencias;
    this.dataInicioReferencia = ocorrencia.dataInicioReferencia;
    this.dataFimReferencia = ocorrencia.dataFimReferencia;
    this.conteudoEmail = ocorrencia.conteudoEmail;
    this.mesesAte = ocorrencia.mesesAte;
    this.semanasAte = ocorrencia.semanasAte;
    this.diasAte = ocorrencia.diasAte;
    this.criterios = ocorrencia.criterios;
  }

  modeloCompleto(): boolean {
    return this.idConfigOcorrenciaAuto !== undefined && this.idUsuario !== undefined;
  }

  getNewInstance(object?: any): ReincidenciaOcorrencia {
    return new ReincidenciaOcorrencia(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/reincidencia-ocorrencia.ts